/* @jsx h */
import { h } from "vue";
import type { Reservation, ReservationRequest } from "../types";
import { ReservationCard } from "../../ReservationTabs/ReservationCard";
import { ReservationRequestCard } from "../../ReservationTabs/ReservationRequestCard";

interface ContentListProps {
  requests: ReservationRequest[];
  reservations: Reservation[];
  isRequestView: boolean;
  loadingMore: boolean;
  onRequestClick: (request: ReservationRequest) => void;
  onReservationClick: (reservation: Reservation) => void;
}

export const ContentList = (props: ContentListProps) => {
  if (props.isRequestView) {
    return (
      <div class="space-y-2">
        {props.requests.map((request) => (
          <ReservationRequestCard
            key={request.id}
            request={request}
            linkedReservation={null}
            onClick={props.onRequestClick}
            hideActions={true}
          />
        ))}
        {props.loadingMore && (
          <div class="flex justify-center py-4">
            <span class="loading loading-spinner loading-md text-primary"></span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div class="space-y-2">
      {props.reservations.map((reservation) => (
        <ReservationCard
          key={reservation.id}
          reservation={reservation}
          onClick={props.onReservationClick}
        />
      ))}
      {props.loadingMore && (
        <div class="flex justify-center py-4">
          <span class="loading loading-spinner loading-md text-primary"></span>
        </div>
      )}
    </div>
  );
};
